// TODO sett opp logging til amplitude
export function loggError(error: Error) {
  console.error(error);
}
